module.exports = __webpack_public_path__ + "static/tablet-apply-21cbca1c72a837300c5ea86340e340a0.png";